import React from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import arraysHaveSameElements from '../../../../../utils/arraysHaveSameElements';
import ActionsSection from '../../../actions-sections/ActionsSection';
import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import MultiselectDropdownNew from '../../../../../components/multiselect-dropdown/MultiselectDropdownNew';
import WithError from '../../../../../components/with-error/WithError';
import { ASSISTANTS_CATEGORY } from '../../../../../constants';

import scss from './AssignedAssistantsSection.module.scss';

function AssignedAssistantsForm({ onSubmit, initialValues }) {
  const { t } = useTranslation('projects');
  const { restart } = useForm();
  const { values, valid } = useFormState();

  const isAssistantsSectionLoading = useSelector((state) => state.projects.isAssistantsSectionLoading);
  const isAccessAssistantsLoading = useSelector((state) => state.projects.isAccessAssistantsLoading);
  const accessAssistants = useSelector((state) => state.projects.accessAssistants);

  const isDirty = compareArrayFormElements(values, initialValues, [
    'activeAllAssistants',
    'activeSelectedAssistants',
    'activeCompressAssistants',
  ]);

  const handleDiscardsChanges = () => {
    restart();
  };

  return (
    <div className={scss.form}>
      <Field name='activeAllAssistants'>
        {({ input, meta }) => (
          <WithLabel variant={LABEL_STYLES.ALIGNED} label={`${t('assistants')}:`} isBold extraClassName={scss.inputRow}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <MultiselectDropdownNew
                value={input.value}
                options={accessAssistants[ASSISTANTS_CATEGORY.GENERATE_ALL]}
                onChange={input.onChange}
                name={input.name}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                placeholder={t('selectAssistants')}
                disableNewOptions
                disabled={isAssistantsSectionLoading || isAccessAssistantsLoading}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <Field name='activeSelectedAssistants'>
        {({ input, meta }) => (
          <WithLabel
            variant={LABEL_STYLES.ALIGNED}
            label={`${t('generateMoreAssistants')}:`}
            isBold
            extraClassName={scss.inputRow}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <MultiselectDropdownNew
                value={input.value}
                options={accessAssistants[ASSISTANTS_CATEGORY.GENERATE_SELECTED]}
                onChange={input.onChange}
                name={input.name}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                placeholder={t('selectAssistants')}
                disableNewOptions
                disabled={isAssistantsSectionLoading || isAccessAssistantsLoading}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <Field name='activeCompressAssistants'>
        {({ input, meta }) => (
          <WithLabel
            variant={LABEL_STYLES.ALIGNED}
            label={`${t('compressAssistants')}:`}
            isBold
            extraClassName={scss.inputRow}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <MultiselectDropdownNew
                value={input.value}
                options={accessAssistants[ASSISTANTS_CATEGORY.COMPRESS]}
                onChange={input.onChange}
                name={input.name}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                placeholder={t('selectAssistants')}
                disableNewOptions
                disabled={isAssistantsSectionLoading || isAccessAssistantsLoading}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <ActionsSection
        dirty={isDirty}
        valid={valid}
        onDiscard={handleDiscardsChanges}
        onSubmit={onSubmit}
        isLoading={isAssistantsSectionLoading}
      />
    </div>
  );
}

export default AssignedAssistantsForm;

const compareArrayFormElements = (values, initialValues, keysArray) => {
  return keysArray.some(
    (key) =>
      !arraysHaveSameElements(
        values[key].map(({ id }) => id),
        initialValues[key].map(({ id }) => id),
      ),
  );
};
